export default __webpack_public_path__ + "static/media/notification2.5bcf0aaf.png";